import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../../components/Tooltip';

const strengthLevels = {
  high: {
    label: 'High',
    description:
      'At least one recent historical correlation of 0.9 or above, or published forecasts.',
  },
  medium: {
    label: 'Medium',
    description:
      'At least one recent historical KPI to Apptopia metric correlations with a strength of 0.8 or above.',
  },
  low: {
    label: 'Low',
    description:
      'No recent historical KPI to Apptopia metric correlations with a strength of 0.8 or above.',
  },
  na: {
    label: 'NA',
    description: 'This company does not have any KPI correlations',
  },
};

// Note: Used in the Comapny page and QV
const DataStrengthIndicator = ({ strength, hideTooltip = false }) => {
  const renderIndicator = (strengthLevel, prefix = '') => (
    <div className={cx('data-strength-indicator', strengthLevel)}>
      {prefix}
      {strengthLevels[strengthLevel]?.label}
    </div>
  );

  const tooltipContent = (
    <div className="data-strength-indicator-tooltip__content">
      <div className="data-strength-indicator-tooltip__header">
        <h5 className="h5">Apptopia Data Strength</h5>
        <p>
          An indicator of the overall strength of correlation of Apptopia’s data to company KPIs
        </p>
      </div>
      {Object.keys(strengthLevels).map((key) => (
        <div key={key} className="data-strength-indicator-tooltip__level">
          {renderIndicator(key)}
          <p>{strengthLevels[key].description}</p>
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip
      content={!hideTooltip ? tooltipContent : null}
      colorVariant="light"
      overlayClassName="data-strength-indicator-tooltip"
    >
      {renderIndicator(strength || 'na', 'Data Strength: ')}
    </Tooltip>
  );
};

DataStrengthIndicator.propTypes = {
  strength: T.string,
  hideTooltip: T.bool,
};

export default DataStrengthIndicator;
